import { render, staticRenderFns } from "./EmailSignupStep.vue?vue&type=template&id=a5036f12&"
import script from "./EmailSignupStep.vue?vue&type=script&lang=ts&"
export * from "./EmailSignupStep.vue?vue&type=script&lang=ts&"
import style0 from "./EmailSignupStep.vue?vue&type=style&index=0&id=a5036f12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports